import React from 'react'
import { CtaButton } from '@repo/ui'

type CtaButtonHandler = (e: React.MouseEvent | React.PointerEvent) => void

export const createBoosterButton = (
  t: (key: string) => string,
  isApplicableToGame: boolean,
  onActivate: CtaButtonHandler
) => (
  <CtaButton
    accentColor="blue"
    className='w-full [border-top-left-radius:0] [border-top-right-radius:0] justify-center'
    label={!isApplicableToGame ? t('Not available for this game') : t('Use now')}
    onClick={onActivate}
    onPointerDown={onActivate}
    status={!isApplicableToGame ? 'inactive' : 'active'}
  />
)

export const createAutoBoosterButton = (t: (key: string) => string) => (
  <CtaButton
    accentColor="blue"
    className='w-full [border-top-left-radius:0] [border-top-right-radius:0] justify-center'
    label={t('Applied automatically')}
    status="inactive"
  />
)

export const createBonusButton = (
  t: (key: string) => string,
  isButtonDisabled: boolean,
  onActivate: CtaButtonHandler,
  disabledReason?: 'game' | 'minBet'
) => {
  let label = t('Use now')
  if (isButtonDisabled) {
    label = disabledReason === 'minBet' ? t('Below minimum bet amount') : t('Not available for this game')
  }

  return (
    <CtaButton
      accentColor="green"
      className='w-full [border-top-left-radius:0] [border-top-right-radius:0] justify-center'
      label={label}
      onClick={onActivate}
      onPointerDown={onActivate}
      status={isButtonDisabled ? 'inactive' : 'active'}
    />
  )
}

export const createUnclaimButton = (
  t: (key: string) => string,
  onDeactivate: CtaButtonHandler
) => (
  <CtaButton
    accentColor="green"
    className='w-full [border-top-left-radius:0] [border-top-right-radius:0] justify-center'
    label={t('Unclaim')}
    onClick={onDeactivate}
    onPointerDown={onDeactivate}
    status="inactive"
  />
)